import { useAuthStore } from '@/stores/auth'
import { getClientIp } from '@/utils/ip'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) {
    try {
      const event = useRequestEvent()
      if (event) {
        const authStore = useAuthStore()
        const ipAddress = getClientIp(event)
        if (ipAddress) {
          authStore.setIpAddress(ipAddress)
        }
      }
    } catch (e) {
      logError(e)
    }
  }
})
